import { useState } from "react";
import { Copy, Check, ExternalLink } from "lucide-react";
import { PARTNER_LINK, DISCOUNT_CODE, DISCOUNT_PERCENT } from "@/lib/constants";
import { trackEvent } from "@/lib/tracking";

const FinalCTASection = () => {
  const [copied, setCopied] = useState(false);

  const handleCopy = () => {
    navigator.clipboard.writeText(DISCOUNT_CODE);
    setCopied(true);
    trackEvent("code_copy", "final_cta");
    setTimeout(() => setCopied(false), 2000);
  };

  return (
    <section className="py-10 md:py-16">
      <div className="container">
        <div className="mx-auto max-w-2xl rounded-2xl border border-primary/20 bg-card p-6 text-center sm:p-8 md:p-10">
          <h2 className="font-display text-lg font-bold text-foreground sm:text-xl md:text-2xl">
            Jetzt {DISCOUNT_PERCENT}&nbsp;% Rabatt sichern
          </h2>
          <p className="mx-auto mt-2 max-w-md text-sm text-muted-foreground">
            Nutze den heilys Rabattcode LONGEVITY und spare auf das gesamte Sortiment – von Rotlichtpanels bis Wearables.
          </p>

          <div className="mt-6 flex flex-col items-center gap-4 sm:flex-row sm:justify-center">
            <button
              onClick={handleCopy}
              className="inline-flex items-center gap-2 rounded-xl border border-border bg-card/80 px-5 py-3 font-display text-xl font-bold tracking-wider text-primary transition-colors hover:bg-secondary sm:text-2xl"
              aria-label="Rabattcode LONGEVITY kopieren"
            >
              {DISCOUNT_CODE}
              {copied ? (
                <Check className="h-4 w-4 text-green-400" aria-hidden="true" />
              ) : (
                <Copy className="h-4 w-4 text-muted-foreground" aria-hidden="true" />
              )}
            </button>

            <a
              href={PARTNER_LINK}
              target="_blank"
              rel="noopener noreferrer nofollow"
              onClick={() => trackEvent("affiliate_click", "final_cta")}
              className="inline-flex items-center justify-center gap-1.5 rounded-lg bg-primary px-6 py-3 text-sm font-semibold text-primary-foreground shadow-lg shadow-primary/25 transition-all hover:shadow-xl hover:shadow-primary/30 hover:brightness-110"
            >
              Zum heilys Shop
              <ExternalLink className="h-3.5 w-3.5" aria-hidden="true" />
            </a>
          </div>

          <p className="mt-4 text-xs text-muted-foreground">
            Partnerlink · Der Preis für dich bleibt unverändert.
          </p>
        </div>
      </div>
    </section>
  );
};

export default FinalCTASection;
